import React, { type ReactNode } from 'react';

import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { Badge, Button, List } from 'antd';
import { Avatar } from 'components';
import { BASE_URL, USER_AVATAR_FOLDER } from 'config';
import { type User } from 'models/user';

type AssignedUser = NonNullable<User['assignedUsers']>[number];

interface DraggableUserItemProps extends React.HTMLAttributes<HTMLDivElement> {
  user: AssignedUser;
  icon: ReactNode;
  onClick: () => void;
  isDragging: boolean;
}

export const DraggableUserItem = ({
  user,
  onClick,
  icon,
  isDragging,
  ...divProps
}: DraggableUserItemProps) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id: user.id });

  const style = {
    transform: isDragging ? 'none' : CSS.Translate.toString(transform),
    visibility: isDragging ? ('hidden' as const) : ('visible' as const),
    cursor: 'grab',
  };

  const src = user.avatar ? `${BASE_URL}${USER_AVATAR_FOLDER}/${user.avatar}` : undefined;

  const stopDrag = (e: React.MouseEvent) => e.stopPropagation();

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners} {...divProps}>
      <List.Item>
        <List.Item.Meta
          avatar={<Avatar src={src} />}
          title={user.name}
          description={
            <>
              <Badge color={user.isActive ? 'green' : 'red'} size="small" text=" " />
              {user.role.replace('_', ' ')}
            </>
          }
        />
        <Button icon={icon} onMouseDown={stopDrag} onClick={onClick} />
      </List.Item>
    </div>
  );
};
